// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo_logoContainer__LkCST","firstName":"logo_firstName__0WAzu","lastName":"logo_lastName__zf9oX","npm":"logo_npm__xX0kG"};